import { UploadedFile } from '@terminal/views/alfred/research/use-user-upload/use-user-upload.types';
import { ChatMode } from '@terminal/views/alfred/use-chat-navigation/useChatNavigation';

export interface CheckChatInputVisibilityArgs {
  files: UploadedFile[];
  isAlfredPage: boolean;
  mode: ChatMode;
  showTools: boolean;
}

export const checkChatInputVisibility = ({
  files,
  isAlfredPage,
  mode,
  showTools,
}: CheckChatInputVisibilityArgs) => {
  const hasValidFiles = files.filter(file => file.status !== 'error').length;

  const showToolsOnNonAlfredPage = !isAlfredPage && showTools;
  const showToolsOnAlfredPage = isAlfredPage && mode === 'research';

  const showChildrenInTextArea =
    (isAlfredPage && mode !== 'research') || (!isAlfredPage && !showTools);
  const showChildrenInTools =
    !isAlfredPage || (isAlfredPage && mode === 'research');

  return {
    hasValidFiles,
    showToolsOnNonAlfredPage,
    showToolsOnAlfredPage,
    showChildrenInTextArea,
    showChildrenInTools,
  };
};
